import $, { data } from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import { NavigateFunction } from 'react-router';
import { Ajax } from '@mabinso-registry/module-commons';
import i18n from '../../../utils/I18n';
import Globals from '../../../utils/Globals';
import ReportCategoryCollection from '../models/ReportCategoryCollection';
import ReportSavedModel from '../models/ReportSavedModel';
import ReportModel from '../models/ReportModel';
import ReportCategoryModel from '../models/ReportCategoryModel';
import ReportCategoryView from './ReportCategoryView';
import EditReportCategoryView from './EditReportCategoryView';
import AlertView from '../../app/views/AlertView';
import ConfirmView from '../../app/views/ConfirmView';
import WaitView from '../../app/views/WaitView';
import Actionbar from '../../app/components/documentexplorer/actionbar/Actionbar';
import html from '../templates/report_list_view.template?raw';
import PlanReportListView from './PlanReportListView';

interface BackboneView extends Backbone.View {
    options: any;
}

interface ViewOptions extends Backbone.ViewOptions<ReportCategoryModel> {
    enableHelp: Function;
    navigate: NavigateFunction;
    editReportCategoryView?: BackboneView;
}

interface SearchParams {
    status: string;
    user: string;
    term: string;
    termNull: string;
    dateFrom: string;
    dateTo: string;
}

interface ReportSavedCount {
    all: number;
    unread: number;
    read: number;
    reports: any;
}

class ReportListView extends Backbone.View {
    static events: Backbone.EventsHash = {
        'keyup input[name="search"]': 'doSearchTerm',
        // 'click #dosearch': 'doSearchTerm',
        'click #dosearch': 'doSearch',
        'change #statussearch': 'doSearch',
        'change #usersearch': 'doSearch',
        'change #datesearchfrom': 'doSearch',
        'change #datesearchto': 'doSearch',
        'click span#deleteFilterItems': 'deleteFilterItems',
        'click button.addReportCategory': 'addReportCategory',
        'click button.listAllPlans': 'listAllPlans',
        'click span#clearFilter': 'clearFilters',
        'click span#closeAll': 'closeAll',
        'click #datesearchfrom': 'triggerDatepicker',
        'focus #datesearchfrom': 'triggerDatepicker',
        'click #datesearchto': 'triggerDatepicker',
        'focus #datesearchto': 'triggerDatepicker',
    };
    options: ViewOptions;
    search: SearchParams | undefined;
    collectionLength: number = 0;
    reportCategoryViews: any;
    constructor(options: ViewOptions) {
        options.events = ReportListView.events;
        super(options);
        this.options = options;
        $('body').scrollTo(0, 0);
        this.reportCategoryViews = [];
    }

    render() {
        const view = this;
        this.reportCategoryViews = [];
        this.$el.spinner();
        const compiled = _.template(html);
        view.$el.html(compiled({ $, Actions: Globals.actions, schemaUserModel: Globals.schemaUserModel }));
        view.renderTemplateSuccess();
        view.$('#reportzeilen').spinner();
        view.loadCategorys();
        view.$('#fieldsetStatussearch,#fieldsetUsersearch').uiselectfield('init');
        return view;
    }
    loadCategorys(search?: SearchParams | undefined) {
        const view = this;
        const maxRows = 10;
        const reportCategory = new ReportCategoryCollection();
        console.log('loadCategorys', search);
        reportCategory.fetch({
            data: view.search,
            success(collection: any) {
                view.collectionLength = collection.length;
                let collectionCount = 0;
                view.$('#reportzeilen').html('');
                if (collection.length > 0) {
                    collection.each(
                        (model: any) => {
                            console.log('get', view.search);
                            const spin = $('<div />').spinner();
                            const el = $('<div />', {
                                id: 'reportcategory' + model.id,
                                'data-id': model.id,
                                class: 'reportcategory reporttyp',
                            });
                            el.append(spin as any);
                            view.$('#reportzeilen').append(el);
                            Ajax.getJson({ url: 'reportsSaved/countReportsSaved', json: { categoryId: model.id, getReportSaved: search !== undefined, maxRows, ...search } }).then(
                                (m: ReportSavedCount) => {
                                    collectionCount += 1;
                                    if (m.reports != null) {
                                        model.set('reports', m.reports);
                                    }
                                    view.addReportCategoryView(model, search, el, maxRows, () => {});
                                    model.view.setReportsSavedCount(m.all, m.unread);
                                    (spin as any).remove();
                                }
                            );
                        },
                        (err: any) => {
                            console.log('Category Done', err);
                        },
                        10
                    );
                    view.collection = collection;
                    // view.checkInWork();
                    view.pollStatus();
                    $('#reportzeilen').prepend('<div id="actionbarHolder"></div>');
                    const actionbar = new Actionbar();
                    const actions = [
                        {
                            className: 'delete',
                            label: $._('report.list.delete'),
                            action: 'click',
                            target: '.report.selected .reportactions .loeschen',
                            confirm: $._('report.list.delete.all.message'),
                        },
                        // {className: 'open', label: 'Öffnen', action: "click", target: '.report.selected .reportactions .link-html', confirm: false},
                        {
                            className: 'close',
                            label: $._('report.list.close'),
                            action: 'click',
                            target: '.reportactions .listSelector.true',
                            confirm: false,
                        },
                    ];
                    actionbar.init('actionbarHolder', actions);
                }
            },
        });
        reportCategory.sortByField('name', 'asc');
    }
    unselectAll() {
        $('.reportactions .listSelector.true').trigger('click');
    }
    addReportCategoryView(model: any, search: any, el: any, maxRows: number, callback?: () => void) {
        const view = this;

        if (!Globals.actions.can('report.list.new.template') && !Globals.actions.can('report.list.delete.category')) {
            $(el).hide();
        }
        // view.$('#reportzeilen').append(el);
        const reportCategoryView = new ReportCategoryView({
            el,
            model,
            afterRender: callback,
            navigate: view.options.navigate,
            reportListView: view,
            enableHelp: view.options.enableHelp,
            search,
            maxRows,
        });
        model.view = reportCategoryView;
        view.reportCategoryViews.push(reportCategoryView);
        reportCategoryView.render();
    }
    onlyone() {
        const view = this;
        if (view.collectionLength === 1) {
            view.$('.typbeschriftung.hasReports .opentype:not(.active)').trigger('click');
        }
    }
    renderTemplateSuccess() {
        const view = this;
        // this.$( "#datesearchfrom" ).fadeOut('slow');
        this.$('#datesearchfrom').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: i18n.t('date.calendar.dateFormat'),
            onSelect(dateText: string) {
                view.$('#datesearchto').datepicker('option', 'minDate', dateText);
                view.$('#report-searchform').validationEngine('updateRule', '#datesearchto', 'past', dateText);
                view.doSearch();
                return true;
            },
        });
        this.$('#datesearchto').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: i18n.t('date.calendar.dateFormat'),
        });
    }

    triggerDatepicker(evt: any) {
        if (evt.type === 'focus') {
            $(evt.target).data('focus', true);
        }
        let pageXfrom = 879;
        const width = 18;
        const pageYfrom = 136;
        const height = 15;
        if (evt.target.id === 'datesearchto') {
            pageXfrom = 1056;
        }
        if (
            $(evt.target).data('focus') === false &&
            $(evt.target).datepicker('widget').is(':visible') &&
            evt.pageX >= pageXfrom &&
            evt.pageX <= pageXfrom + width &&
            evt.pageY >= pageYfrom &&
            evt.pageY <= pageYfrom + height
        ) {
            this.$(evt.target as any).datepicker('hide');
        } else {
            this.$(evt.target as any).datepicker('show');
        }
        if (evt.type === 'click') {
            $(evt.target).data('focus', false);
        }
    }
    clearFilters() {
        const view = this;
        view.$('#datesearchfrom').datepicker('setDate', '');
        view.$('#datesearchto').datepicker('setDate', '');
        view.$('#statussearch').uiselectfield('setValue', '');
        view.$('#usersearch').uiselectfield('setValue', '');
        view.$('#datesearchto').datepicker('option', 'minDate', null);
        view.$('#report-searchform').validationEngine('updateRule', '#datesearchto', 'past', null);
        view.$('#namesearch').val('');
        view.doSearch();
        view.closeAll();
        view._filteredIds = [];
        $.scrollTo(0, 200);
    }
    closeAll() {
        _.each(this.reportCategoryViews, (reportCategoryView) => {
            _.each(reportCategoryView.reportViews, (reportView) => {
                reportView.triggerReportsSaved(false);
            });
            reportCategoryView.triggerReports(false);
        });
        /* $(".typbeschriftung.hasReports.active").trigger('click');
        $(".reporttitel.hasReportsSaved.active").trigger('click'); */
        $.scrollTo(0, 200);
    }
    addReportCategory() {
        const view = this;
        if (_.isUndefined(view.options.editReportCategoryView)) {
            view.options.editReportCategoryView = new EditReportCategoryView({
                reportListView: view,
            });
        }
        if (view.options.editReportCategoryView !== undefined) {
            view.options.editReportCategoryView.model = new ReportCategoryModel();
            view.options.editReportCategoryView.render();
        }
    }
    listAllPlans() {
        const view = this;
        const list = new PlanReportListView({
            showAll: true,
        });
        list.render();
    }
    _checkStatus(view: Backbone.View) {
        const search = this.$('#statussearch').val();
        if (search === '' || (view.model as any).hasStatus(search)) {
            return true;
        }
        return false;
    }
    _checkUserid(view: Backbone.View) {
        const search = this.$('#usersearch').val();
        if (search === '' || view.model.get('user_id') + '' === search) {
            return true;
        }
        return false;
    }
    _checkName(view: Backbone.View) {
        const search = this.$('input[name="search"]').val();
        // if (search === '') {
        //     return false;
        // }
        const regExp = new RegExp('^' + search, 'i');
        const name = view.$('span.description').html();
        if (search === undefined || search === '' || (name !== undefined && name.search(regExp) !== -1)) {
            return true;
        }
        return false;
    }
    _checkDate(view: Backbone.View) {
        let dateFrom: any = this.$('#datesearchfrom').val() as string;
        let dateTo: any = this.$('#datesearchto').val();
        const value = Date.parse(view.$('td.reportname').html());
        let ret = true;
        if (dateFrom !== '') {
            dateFrom = Date.parse(dateFrom);
            if (dateFrom.compareTo(value) === 1) {
                ret = false;
            } else {
                ret = true;
            }
        }
        if (ret && dateTo !== '') {
            dateTo = Date.parse(dateTo);
            dateTo = new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate(), 23, 59, 59);
            if (dateTo.compareTo(value) === -1) {
                ret = false;
            } else {
                ret = true;
            }
        }
        return ret;
    }
    _checkFields(model: ReportListView) {
        const that = this;
        if (that._checkStatus(model) && that._checkName(model) && that._checkDate(model) && that._checkUserid(model)) {
            return true;
        }
        return false;
    }
    _filteredIds: any;
    doSearchTerm(evt: any) {
        const term = this.$('input[name="search"]').val();
        if (evt.keyCode === 13 || String(term).length === 0) {
            // if (String(term).length > 2 || String(term).length === 0) {
            this.doSearch();
            // }
        }
    }
    doSearch() {
        const view = this;
        if (view.$('#report-searchform').validationEngine('validate')) {
            const status = this.$('#statussearch').val() as string;
            const user = this.$('#usersearch').val() as string;
            const term = this.$('input[name="search"]').val() as string;
            const dateFrom: any = this.$('#datesearchfrom').val() as string;
            const dateTo: any = this.$('#datesearchto').val() as string;
            console.log('doSearch', status, user, term, dateFrom, dateTo);
            view.$('#reportzeilen').empty();
            view.$('#reportzeilen').spinner();
            let search: SearchParams | undefined;
            if (status !== '' || user !== '' || term !== '' || dateFrom !== '' || dateTo !== '') {
                search = {
                    status: status as string,
                    user: user as string,
                    term: term as string,
                    dateFrom: dateFrom as string,
                    dateTo: dateTo as string,
                    termNull: $._('report.list.template.description'),
                };
            }
            view.loadCategorys(search);
        }
    }
    openAfterSearch(that, isClear: boolean = false) {
        that._filteredIds = [];
        _.each(that.reportCategoryViews, (reportCategoryView) => {
            let hasResultsTyp = false;
            _.each(reportCategoryView.reportViews, (reportView) => {
                let hasResults = false;
                _.each(reportView.reportSavedViews, (reportSavedView) => {
                    reportSavedView.hideForSearch(false);
                    if (that._checkFields(reportSavedView)) {
                        that._filteredIds.push(reportSavedView.model.id);
                        hasResults = true;
                    } else {
                        reportSavedView.hideForSearch(true);
                    }
                });
                if (hasResults) {
                    hasResultsTyp = true;
                    reportView.reportHasReportsSaved(true);
                    if (isClear !== true) {
                        reportView.triggerReportsSaved(true); // Ticket https://mabinso.atlassian.net/browse/MABINSO-2360 Das hier verhindert aufklappen.
                        $('html, body').stop(true);
                    }
                    reportView.hideReportDescription(false);
                } else {
                    reportView.hideReportDescription(true);
                    reportView.triggerReportsSaved(false);
                }
            });
            if (hasResultsTyp) {
                reportCategoryView.categoryHasReports(true);
                if (isClear !== true) {
                    reportCategoryView.triggerReports(true); // Ticket https://mabinso.atlassian.net/browse/MABINSO-2360 Das hier verhindert aufklappen.
                }
            } else {
                reportCategoryView.triggerReports(false);
            }
        });
        $.scrollTo(0, 200);
    }
    doSearchOld(isClear?: boolean) {
        const that = this;
        if (that.$('#report-searchform').validationEngine('validate')) {
            that._filteredIds = [];
            _.each(this.reportCategoryViews, (reportCategoryView) => {
                let hasResultsTyp = false;
                _.each(reportCategoryView.reportViews, (reportView) => {
                    let hasResults = false;
                    _.each(reportView.reportSavedViews, (reportSavedView) => {
                        reportSavedView.hideForSearch(false);
                        if (that._checkFields(reportSavedView)) {
                            that._filteredIds.push(reportSavedView.model.id);
                            hasResults = true;
                        } else {
                            reportSavedView.hideForSearch(true);
                        }
                    });
                    if (hasResults) {
                        hasResultsTyp = true;
                        reportView.reportHasReportsSaved(true);
                        if (isClear !== true) {
                            reportView.triggerReportsSaved(true); // Ticket https://mabinso.atlassian.net/browse/MABINSO-2360 Das hier verhindert aufklappen.
                        }
                        reportView.hideReportDescription(false);
                    } else {
                        reportView.hideReportDescription(true);
                        reportView.triggerReportsSaved(false);
                    }
                });
                if (hasResultsTyp) {
                    reportCategoryView.categoryHasReports(true);
                    if (isClear !== true) {
                        reportCategoryView.triggerReports(true); // Ticket https://mabinso.atlassian.net/browse/MABINSO-2360 Das hier verhindert aufklappen.
                    }
                } else {
                    reportCategoryView.triggerReports(false);
                }
            });
            this.countReports();
            $.scrollTo(0, 200);
        }
        if (that._filteredIds.length === 0) {
            that.closeAll();
        }
    }
    countReports() {
        _.each(this.reportCategoryViews, (reportCategoryView) => {
            _.each(reportCategoryView.reportViews, (reportView) => {
                if (reportView.length > 0) {
                    reportView.countReportSavedItems();
                }
            });
        });
    }
    reportSavedPoll: any;
    pollStatus() {
        const view = this;
        this.reportSavedPoll = new ReportSavedModel();
        this.reportSavedPoll.pollStatus((reportSaved: any) => {
            console.log('Poll Change Event Received');
            console.log(Globals.schemaUserModel.id + ' vs ' + reportSaved.get('schema_id'));
            if (Globals.schemaUserModel.id === reportSaved.get('schema_id')) {
                const category = view.collection.get(reportSaved.get('reportcategory_id')) as any;
                if (category != null) {
                    const report = category.view.collection.get(reportSaved.get('report_id'));
                    if (report != null) {
                        let oldRs;
                        if (!_.isUndefined(report.view.collection)) {
                            oldRs = report.view.collection.get(reportSaved.id);
                        }
                        if (oldRs != null) {
                            console.log('update');
                            oldRs.view.setStatus(reportSaved);
                        } else {
                            console.log('add');
                            // Update Modal Wait View
                            const modalWait = $('div.modalWait');
                            if (modalWait) {
                                modalWait.find('.modalYes').show();
                                modalWait.find('.modalYes').data('id', reportSaved.id);
                            }
                            report.view.addReportSavedView(reportSaved, 'after');
                        }
                    }
                }
            }
        });
    }
    stopPollStatus() {
        if (this.reportSavedPoll != null) {
            this.reportSavedPoll.closePollStatus();
            this.reportSavedPoll = null;
        }
    }
    remove() {
        this.stopPollStatus();
        this.$el.remove();
        return this;
    }
    deleteFilterItems() {
        const that = this;
        if (that._filteredIds == null || _.size(that._filteredIds) === 0) {
            AlertView.show({
                title: $._('report.deleteFilterItems.noitems.title'),
                message: $._('report.deleteFilterItems.noitems.message'),
            });
        } else {
            ConfirmView.show({
                title: $._('report.deleteFilterItems.delete.title'),
                message: $._('report.deleteFilterItems.delete.message', _.size(that._filteredIds).toString()),
                yesFunc() {
                    const waitView = new WaitView({
                        message: $._('report.deleteFilterItems.delete.wait'),
                    });
                    ReportModel.deleteItems({
                        items: that._filteredIds,
                        success() {
                            setTimeout(() => {
                                waitView.remove();
                                AlertView.show({
                                    message: $._('report.deleteFilterItems.delete.success'),
                                    okFunc() {
                                        that.render();
                                    },
                                });
                            }, 5000);
                        },
                    });
                },
            });
        }
    }
}

export default ReportListView;
